import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Context } from 'src/app/shared/models/context';
import { Message } from 'src/app/shared/models/domain';
import { Qualification } from 'src/app/shared/models/personnel';
import { CommonService } from 'src/app/shared/services/common.service';
import { PersonalService } from 'src/app/shared/services/personal.service';

@Component({
  selector: 'app-manage-employee-qualification',
  templateUrl: './manage-employee-qualification.component.html',
  styleUrls: ['./manage-employee-qualification.component.scss']
})
export class ManageEmployeeQualificationComponent implements OnInit {
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  public qualificationForm: FormGroup;
  private modified: boolean = false;
  public submitted: boolean = false;
  @Input() qualification: Qualification;
  @Input() context: Context;
  selectedFile: File | null = null;



  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private personnalService: PersonalService,
    private commonService: CommonService) { }

  ngOnInit(): void {
    this.setQualification(this.qualification);
    console.log('Form Valid:', this.qualificationForm.valid);
  console.log('Form Errors:', this.qualificationForm.errors);
  console.log('Qualification Type Errors:', this.qualificationForm.get('qualificationType')?.errors);
  }

  public setQualification(qualification?: Qualification) {
    if (!qualification)
      qualification = {
        id: null,
        qualificationType: '',
        degreeName: '',
        institutionName: '',
        specialization: '',
        startDate: '',
        endDate: '',
        gradeOrScore: '',
        documentUrl: '',
        verifiedAt: '',
        remarks: '',
        verificationStatus: 'PENDING',
        employeeId: this.context.employeeId,
        employeeName: '',
        verifiedById: null,
        verifiedByName: '',
        disabled: false
      } as Qualification;
    this.qualificationForm = this.fb.group({
      id: this.fb.control(qualification?.id || null),
      employeeName: this.fb.control(qualification.employeeName),
      employeeId: this.fb.control(this.context.employeeId),
      qualificationType: this.fb.control(qualification.qualificationType, [Validators.required]),
      degreeName: this.fb.control(qualification.degreeName, [Validators.required]),
      institutionName: this.fb.control(qualification.institutionName, [Validators.required]),
      specialization: this.fb.control(qualification.specialization),
      startDate: this.fb.control(this.datePipe.transform(qualification?.startDate || '', 'yyyy-MM-dd'), [Validators.required]),
      endDate: this.fb.control(this.datePipe.transform(qualification?.endDate || '', 'yyyy-MM-dd')),
      gradeOrScore: this.fb.control(qualification.gradeOrScore),
      verificationStatus: this.fb.control(qualification.verificationStatus),
      verifiedById: this.fb.control(qualification.verifiedById),
      disabled: this.fb.control(qualification.disabled),


    });
    this.qualificationForm.valueChanges.subscribe(value => this.modified = true);
  }

  get q() {
    return this.qualificationForm.controls;
  }

  public saveQualification(inProgress?: any) {
    this.submitted = true;
    if (this.qualificationForm.valid) {
      const qualification: Qualification = this.qualificationForm.value;
      inProgress.value = true; 
      if (qualification.id) {
        this.personnalService.updateQualification(qualification.id, qualification).subscribe({
          next: (response: Message) => {
            inProgress.value = false;
            if (response) {
              this.commonService.setToastr(200, response.text);
              if (this.selectedFile) {
                this.uploadDocument(qualification.id, this.selectedFile);
              }
              this.passEntry.emit(response);
              this.activeModal.close(response);
            } else {
              this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
            }
          },
          error: (error: HttpErrorResponse) => {
            inProgress.value = false;
            this.commonService.setToastr(500, error?.error?.name || error.error);
          },
        });
  
      } else {
        this.personnalService.createQualification(qualification).subscribe({
          next: (response: Message) => {
            inProgress.value = false;
            if (response && response.payload) {
              const createdQualificationId = response.payload;
              if (this.selectedFile) {
                this.uploadDocument(createdQualificationId, this.selectedFile);
              }
              this.commonService.setToastr(200, response.text);
              this.passEntry.emit(response);
              this.activeModal.close(response);
            } else {
              this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
            }
          },
          error: (error: HttpErrorResponse) => {
            inProgress.value = false;
            this.commonService.setToastr(500, error?.error?.name || error.error);
          },
        });
      }
  
    } else {
      this.qualificationForm.markAllAsTouched();
    }
  }
  
  
  public onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input?.files?.length) {
      const file = input.files[0];
      const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf']; // Allow JPEG, PNG, and PDF files
        if (!allowedTypes.includes(file.type)) {
        this.commonService.setToastr(400, 'Only JPEG, PNG, and PDF files are allowed.');
        return;
      }
        this.selectedFile = file;
      // this.commonService.setToastr(200, 'File selected successfully!');
    } else {
      // this.commonService.setToastr(400, 'No file selected.');
    }
  }

  private uploadDocument(qualificationId: number, file: File): void {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('QualificationId', qualificationId.toString());
    this.personnalService.uploadQualificationFile(qualificationId, formData).subscribe({
      next: (response) => {
        this.passEntry.emit(response);
        this.commonService.setToastr(200, 'Document uploaded successfully!');
      },
      error: (error: HttpErrorResponse) => {
        this.commonService.setToastr(500, error?.error?.name || error.error);
      }
    });
  }
}